import { api } from './client'

export type TimeLogSource = 'manual' | 'inferred' | 'adjusted'

export interface TimeLog {
  id: string
  task_id: string
  user_id: string
  duration_mins: number
  source: TimeLogSource
  notes?: string
  logged_at: string
  created_at: string
  updated_at: string
}

export interface TimeLogListResponse {
  items: TimeLog[]
  total: number
  page: number
  per_page: number
}

export interface CreateTimeLogRequest {
  task_id: string
  duration_mins: number
  source?: TimeLogSource
  notes?: string
  logged_at?: string
}

export interface TimeLogFilters {
  task_id?: string
  user_id?: string
  from_date?: string
  to_date?: string
  page?: number
  per_page?: number
}

export interface TimeLogSummaryByDate {
  date: string
  total_mins: number
}

export interface TimeLogSummaryByTask {
  task_id: string
  task_title: string
  total_mins: number
}

export interface TimeLogSummaryByClient {
  client_id: string
  client_name: string
  total_mins: number
}

export interface TimeLogSummary {
  total_hours: number
  by_date: TimeLogSummaryByDate[]
  by_task: TimeLogSummaryByTask[]
  by_client: TimeLogSummaryByClient[]
}

export interface TimeLogSummaryFilters {
  user_id?: string
  from_date?: string
  to_date?: string
}

export const timelogsApi = {
  /**
   * List time logs with filters
   */
  list: (filters?: TimeLogFilters): Promise<TimeLogListResponse> => {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, String(value))
        }
      })
    }
    const query = params.toString()
    return api.get(`/api/v1/timelogs${query ? `?${query}` : ''}`)
  },

  /**
   * Create a new time log entry
   */
  create: (data: CreateTimeLogRequest): Promise<TimeLog> => {
    return api.post('/api/v1/timelogs', data)
  },

  /**
   * Get time log summary with breakdowns
   */
  summary: (filters?: TimeLogSummaryFilters): Promise<TimeLogSummary> => {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, String(value))
        }
      })
    }
    const query = params.toString()
    return api.get(`/api/v1/timelogs/summary${query ? `?${query}` : ''}`)
  },
}
